import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import SettingLeftSideBar from './SettingLeftSideBar';
import SettingNotification from './Notification/SettingNotification';
import SettingAccess from './access/SettingAccess';
import SettingPayment from './payment/SettingPayment';
import SecuritySettings from './security/SecuritySettings';
import './settingsComponent.scss';
import ChangeDetectedItem from '../../../template/ChangeDetectedItem/ChangeDetectedItem';
import {useChanges} from '../../../../hooks/useChanges';
import {settingsApi} from '../../../../http/Api';
import {getSettings} from '../../../../store/Settings';

const SettingsComponent = ({eqv}) => {
  const {handleSaveChanges, cancelChanges, addChangeToStore} = useChanges();
  const [navItemSelect, setNavItemSelect] = useState('Notification');
  const {settingsState} = useSelector((state) => state.settings);
  const {membersGlobalState} = useSelector((state) => state.members);
  const {rolesGlobalState} = useSelector((state) => state.roles);
  const {changesDetected} = useSelector((state) => state.changeDetected);

  return (
    <div className="setting_component_wrap setting_component_wrap_all-block">
      <div className="overview_component_content_head">
        <h4>Themis and Dashboard Global Settings</h4>
        <p>
          Get a summary of your server's security, including details on detected threats, recent
          moderation actions, and user activity.
        </p>
      </div>
      <div className="setting_component_content">
        <div className="setting_component_content_left_side">
          <h3>Settings</h3>
          <SettingLeftSideBar item={navItemSelect} setItem={setNavItemSelect} />
        </div>
        <div className="setting_component_content_right_side">
          {navItemSelect === 'Notification' && <SettingNotification />}
          {navItemSelect === 'Access' && (
            <SettingAccess
              data={settingsState?.data}
              roles={rolesGlobalState?.data?.roles || []}
              members={membersGlobalState?.data?.members || []}
              addChangeToStore={addChangeToStore}
            />
          )}
          {navItemSelect === 'Payment' && (
            <SettingPayment
              guildId={settingsState?.data?.id}
              guildName={settingsState?.data?.name}
            />
          )}
          {navItemSelect === 'Security' && (
            <SecuritySettings securityKey={settingsState?.data?.key} />
          )}
        </div>
      </div>
      {changesDetected && (
        <ChangeDetectedItem
          cancel={cancelChanges}
          onSave={() => handleSaveChanges(settingsApi.updateSettings, getSettings)}
        />
      )}
    </div>
  );
};

export default SettingsComponent;
